import React from "react";

const MovieDetailsShimmer = () => {
  return (
    <div>
      <div className="moviePageDetail moviePageDetailShimmer">
        <h1></h1>
        <div className="ratings ratingsShimmer">
          <img src="" alt="Star" />
          <span>{}</span>
          <span></span>
        </div>
        <div className="availableIn">
          <span>{}</span>
        </div>
        <div className="availableLanguage availableLanguageShimmer">
          <span></span>
        </div>
        <div className="movieTimeTypeDate movieTimeTypeDateShimmer">
          <p></p>
        </div>
        <button></button>
      </div>
    </div>
  );
};

export default MovieDetailsShimmer;
